<template>
  <div>
    <v-toolbar class="primary elevation-0 small-extension" dark>
      <h1 class="titulo">Adicionar imóvel</h1>
    </v-toolbar>
    <form v-on:submit.prevent="onSubmit">
      <v-layout row wrap class="pt-5">
        <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
          <v-container fluid>
            <v-layout row wrap class="mt-3">
              <v-flex xs12>
                <v-text-field
                  autofocus
                  autocomplete="off"
                  v-model="form.fields.apelido"
                  label="Nome do imóvel"
                  v-validate="'required'"
                  name="apelido"
                  data-vv-as="nome do imóvel"
                  :error-messages="errors.has('apelido') ? errors.first('apelido') : []"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-bind:items="proprietarios"
                  v-model="form.fields.proprietarioSelect"
                  label="Dono do imóvel"
                ></v-select>
                <transition name="slide-x-transition" v-if="form.fields.proprietarioSelect === 'Preencher manualmente'">
                  <v-text-field
                    autocomplete="off"
                    v-model="form.fields.proprietario"
                    label="Nome do proprietário"
                  >
                  </v-text-field>
                </transition>
              </v-flex>
              <v-flex xs12>
                <v-select
                  v-bind:items="tipos"
                  v-model="form.fields.tipoSelect"
                  label="Tipo do imóvel"
                ></v-select>
                <transition name="slide-x-transition" v-if="form.fields.tipoSelect === 'Preencher manualmente'">
                  <v-text-field
                    autocomplete="off"
                    v-model="form.fields.tipo"
                    label="Tipo do imóvel"
                  >
                  </v-text-field>
                </transition>
              </v-flex>
              <v-flex xs12>
                <div v-if="form.fields.savoynet.length > 0" class="mb-2">
                  <v-chip
                    v-for="(item, index) in form.fields.savoynet"
                    :key="`savoynet-${item}-${index}`"
                    close
                    class="mr-2 mb-2"
                    @input="removeSavoyNet(index)"
                  >
                    {{ item }}
                  </v-chip>
                </div>
                <v-text-field
                  autocomplete="off"
                  v-model="savoynetInput"
                  label="SavoyNet"
                  hint="Use Enter, vírgula, ponto e vírgula ou nova linha."
                  persistent-hint
                  @keydown="onSavoyNetKeydown"
                  @input="onSavoyNetInput"
                  @blur="commitSavoyNetInput"
                  @paste="onSavoyNetPaste"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row class="text-xs-center mt-4">
              <v-flex xs12 sm8 offset-sm2 md6 offset-md3>
                <v-btn
                  type="submit"
                  outline
                  block
                  large
                  class="secondary secondary--text ma-0"
                  :disabled="isFormInvalid"
                >
                  Criar
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </form>
  </div>
</template>

<script>
  import _ from 'lodash'
  import axios from 'axios'
  import { apiURL } from '@/config'
  import { normalizeSavoyNetList, splitSavoyNetValues } from '@/utils/savoynet'
  import HeadersAdicionar from './Headers/HeadersAdicionar'

  export default {
    components: {
      HeadersAdicionar
    },
    data () {
      return {
        savoynetInput: '',
        form: {
          fields: {
            apelido: '',
            proprietarioSelect: '',
            proprietario: '',
            tipoSelect: '',
            tipo: '',
            savoynet: []
          }
        }
      }
    },
    mounted () {
      if (!this.$hasGranularPermission('info', 'add')) {
        this.$router.push({ name: 'ImoveisLista' })
      }
      this.$store.dispatch('imoveis/loadProprietarios')
    },
    computed: {
      imovelTipoSugestoes () {
        return _.uniq(
          _.compact(
            _.map(this.$store.getters['constants/imovelTipo'], this.getImovelTipoItemValue)
          )
        )
      },
      tipos () {
        const tipos = this.imovelTipoSugestoes.slice(0)
        tipos.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true })
        return tipos
      },
      proprietarios () {
        let proprietarios = this.$store.getters['imoveis/proprietarios'].slice(0)

        proprietarios.unshift({ text: 'Preencher manualmente', value: 'Preencher manualmente' }, { divider: true })

        return proprietarios
      },
      isFormInvalid () {
        return Object.keys(this.fields).some(key => this.fields[key].invalid) || _.isEmpty(_.omitBy(this.form.fields, _.isEmpty))
      }
    },
    watch: {
      'form.fields.proprietarioSelect' (value) {
        if (value === 'Preencher manualmente') {
          this.form.fields.proprietario = ''
        } else {
          this.form.fields.proprietario = value
        }
      },
      'form.fields.tipoSelect' (value) {
        if (value === 'Preencher manualmente') {
          this.form.fields.tipo = ''
        } else {
          this.form.fields.tipo = value
        }
      }
    },
    methods: {
      getImovelTipoItemValue (item) {
        if (item && typeof item === 'object') {
          return (item.text || item.value || '').trim()
        }

        return String(item || '').trim()
      },
      normalizeTipo (value) {
        return String(value || '').trim().replace(/\s+/g, ' ')
      },
      addSavoyNetValues (values) {
        this.form.fields.savoynet = normalizeSavoyNetList(this.form.fields.savoynet.concat(values))
      },
      commitSavoyNetInput () {
        if (!this.savoynetInput) {
          return
        }

        this.addSavoyNetValues(splitSavoyNetValues(this.savoynetInput))
        this.savoynetInput = ''
      },
      onSavoyNetInput (value) {
        if (!/[,\n;]/.test(value)) {
          return
        }

        this.addSavoyNetValues(splitSavoyNetValues(value))
        this.savoynetInput = ''
      },
      onSavoyNetKeydown (event) {
        if (event.key !== 'Enter' && event.key !== ',' && event.key !== ';') {
          return
        }

        event.preventDefault()
        this.commitSavoyNetInput()
      },
      onSavoyNetPaste (event) {
        const clipboardData = event.clipboardData || window.clipboardData
        const pastedText = clipboardData ? clipboardData.getData('text') : ''

        if (!pastedText) {
          return
        }

        event.preventDefault()
        this.addSavoyNetValues(splitSavoyNetValues(pastedText))
        this.savoynetInput = ''
      },
      removeSavoyNet (index) {
        this.form.fields.savoynet.splice(index, 1)
      },
      onSubmit () {
        this.$store.dispatch('utils/showLoading')

        this.$validator.validateAll().then((result) => {
          if (result) {
            this.commitSavoyNetInput()

            const payload = {
              apelido: this.form.fields.apelido,
              proprietario: this.form.fields.proprietario,
              tipo: this.normalizeTipo(this.form.fields.tipo),
              savoynet: normalizeSavoyNetList(this.form.fields.savoynet)
            }

            axios.post(`${apiURL}/imoveis`, payload).then((response) => {
              this.$router.push({ name: 'ImoveisDetalhesResumo', params: { id: response.data.data.id } })
              this.$store.dispatch('utils/hideLoading')
            }, () => {
              this.$store.dispatch('utils/showSnackbar', {
                text: 'Servidor indisponível. Tente novamente mais tarde.'
              })
              this.$store.dispatch('utils/hideLoading')
            })
          } else {
            this.$store.dispatch('utils/showSnackbar', {
              type: 'error',
              text: 'Preencha os campos corretamente'
            })
            this.$store.dispatch('utils/hideLoading')
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ImoveisAdicionar.vue?553ff125